import { render, staticRenderFns } from "./IngredientModalDialogRename.vue?vue&type=template&id=335ab6bb&scoped=true"
import script from "./IngredientModalDialogRename.vue?vue&type=script&lang=js"
export * from "./IngredientModalDialogRename.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335ab6bb",
  null
  
)

export default component.exports